import { DirtyFieldsType, Operation } from '@occc-app/offerHelpers/types';
import { isFieldDirty } from '@occc-app/offerHelpers/utils';
import {
  StoredValueProgramCreateMutationVariables,
  StoredValueProgramUpdateMutationVariables,
} from '@occc/graphql';

import { StoredValueConfigureFormValues } from './stored-value-configure-form.types';

const hasStoredValueProgramDirtyFields = (dirtyFields: DirtyFieldsType): boolean =>
  isFieldDirty<StoredValueConfigureFormValues>(dirtyFields, 'storedValueDiscount') ||
  isFieldDirty<StoredValueConfigureFormValues>(dirtyFields, 'name');

const storedValueProgramCreateOperation = (
  offerId: string,
  values: StoredValueConfigureFormValues,
): Operation<'storedValueProgramCreate', StoredValueProgramCreateMutationVariables> => {
  if (!values.chainId) {
    throw new Error('Chain ID is required to create stored value program');
  }

  return {
    name: 'storedValueProgramCreate',
    variables: {
      input: {
        chainId: values.chainId,
        discountingOfferId: offerId,
        programName: values.name,
        pointsPerConversion: values.storedValueDiscount.pointsPerConversion,
        moneyPerConversion: values.storedValueDiscount.moneyPerConversion,
        minPointsPerConversion: values.storedValueDiscount.minPointsPerConversion,
        maxPointsPerConversion: values.storedValueDiscount.maxPointsPerConversion,
        expirationDays: values.storedValueDiscount.expirationDays,
      },
    },
  };
};

const storedValueProgramUpdateOperation = (
  storedValueProgramId: string,
  values: StoredValueConfigureFormValues,
): Operation<'storedValueProgramUpdate', StoredValueProgramUpdateMutationVariables> => ({
  name: 'storedValueProgramUpdate',
  variables: {
    input: {
      id: storedValueProgramId,
      programName: values.name,
      pointsPerConversion: values.storedValueDiscount.pointsPerConversion,
      moneyPerConversion: values.storedValueDiscount.moneyPerConversion,
      minPointsPerConversion: values.storedValueDiscount.minPointsPerConversion,
      maxPointsPerConversion: values.storedValueDiscount.maxPointsPerConversion,
      expirationDays: values.storedValueDiscount.expirationDays,
    },
  },
});

export const getStoredValueProgramOperations = (
  offerId: string,
  values: StoredValueConfigureFormValues,
  dirtyFields: DirtyFieldsType,
): Operation[] => {
  const storedValueProgramId = values.storedValueDiscount.id;

  if (!storedValueProgramId) {
    return [storedValueProgramCreateOperation(offerId, values)];
  }

  if (!hasStoredValueProgramDirtyFields(dirtyFields)) {
    return [];
  }

  return [storedValueProgramUpdateOperation(storedValueProgramId, values)];
};
